export enum ActionSteps {
    PRIMARY_START = 0,
    RESIDENCE = 2,
    PRIMARY_END = 6,
    COSIGNER_RESIDENCE = 9,
    TERMS_STEP = 13,
    FINAL_STEP = 15,
}
